import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// CORRECTED IMPORTS: Matching the exact filenames in your folder
import stockImg from "../../Assets/Projects/stock.png";  // For Stock Market
import leaf from "../../Assets/Projects/leaf.png";       // For AI Vision
import editor from "../../Assets/Projects/editor.png";   // For Backend (replaced missing 'emotion.png')

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          
          {/* Project 1: Stock Market Data Warehouse */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor} 
              isBlog={false}
              title="Stock Market Data Warehouse"
              description="Built an end-to-end Python ETL system that extracts stock data via APIs, cleans it using Pandas, and stores results in a MySQL Data Warehouse. Designed a Star Schema for optimal querying and integrated Power BI dashboards to track performance metrics and anomalies."
              ghLink="https://github.com/raghavmenon/stock-data-warehouse"
            />
          </Col>

          {/* Project 2: AI-Based Vision System */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf} 
              isBlog={false}
              title="AI-Based Vision System"
              description="Developed a prototype vision module using OpenCV and Python for detecting color and shape patterns. Implemented object recognition algorithms and thresholding techniques suitable for industrial image data and robotic inspection systems."
              ghLink="https://github.com/raghavmenon/ai-vision-system"
            />
          </Col>

          {/* Project 3: Backend Model */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={stockImg} 
              isBlog={false}
              title="Backend Model"
              description="Developed a high-performance backend model for Tredence AI. Focused on optimizing data flow and processing speed for large-scale datasets."
              ghLink="https://github.com/raghavvmenon7/QuantomFlowEngine--Tredence-AI-Assignment"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;